export const SELECT_TAB = 'selectTab';
export const SELECT_SECTION = 'SELECT_SECTION';
export const SET_CONTACTS = 'SET_CONTACTS';
export const CONTACTS_PROCESSING = 'CONTACTS_PROCESSING';
export const SET_CONTACTS_ERROR = 'SET_CONTACTS_ERROR';



// WEBPACK FOOTER //
// ./src/components/contact/mutation.js